<template>
  <div class="menu-wrapper">
    <ul :class="['menu-list', isScroll ? '' : 'inline']">
      <li class="menu-item" v-for="item in items" :class="{ active: item.active }" @click="onChangeMenu(item[uniqueKey])" v-if="!item.hide">
        {{item.name}}
        <span class="tag" v-if="item.isFree">免费试听</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    items: Array,
    uniqueKey: {
      type: String,
      default: 'id',
    },
    isScroll: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    onChangeMenu(value) {
      this.$emit('on-change-menu', value)
    },
  },
};
</script>

<style scoped lang="scss">
.menu-wrapper {
  height: 37px;
  border-bottom: 2px solid #f0f0f0;
  background-color: #fff;
  box-sizing: border-box;

  .menu-list {
    margin: 0;
    padding: 0;
    padding: 0 20px;
    height: 37px;
    overflow-x: auto;
    list-style: none;
    white-space: nowrap;

    &.inline {
      display: flex;
      justify-content: space-around;
      overflow: visible;
    }
  }

  .menu-item {
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: #101010;
    line-height: 35px;
    height: 35px;
    margin: 0 10px;
    z-index: 10;

    &.active {
      color: #e51c23;

      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #e51c23;
        z-index: 10;
      }
    }
  }

  .tag {
    padding: 0 5px;
    font-size: 10px;
    line-height: 15px;
    color: #fff;
    background-color: #e51c23;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
</style>
